import React from 'react'
import { Link, useResolvedPath } from 'react-router-dom'
import { Content } from 'ui'
import { NewCityForm, NewDistrictForm, NewSchoolForm } from '../../../Forms'
import { DataManagementShell } from './DataManagementShell'

const AsideContent: React.FC = () => {
  const { pathname } = useResolvedPath('/admin/management')
  const url = pathname
  return (
    <>
      <Link to={`${url}/manage/`.replace('//', '/')}>
        <Content.ActionButton label="Manage Districts" />
      </Link>
      <Link to={`${url}/import/`.replace('//', '/')}>
        <Content.ActionButton label="Import Bulk Data" />
      </Link>
    </>
  )
}

const WRAPPER_STYLES: string = 'flex flex-col flex mr-0 xl:mr-16'

const MainContent: React.FC = () => {
  return (
    <div className={WRAPPER_STYLES}>
      <NewSchoolForm />
      <NewDistrictForm />
      <NewCityForm />
    </div>
  )
}

interface DistrictsQuickActionsViewProps {}

export const DistrictsQuickActionsView: React.FC<DistrictsQuickActionsViewProps> = () => {
  return (
    <DataManagementShell
      heading="Schools & District Admin"
      subHeading="Quick Actions"
      returnUrl="/admin/management"
      linkText="back to data management home"
      main={<MainContent />}
      aside={<AsideContent />}
    />
  )
}
